import { TipoSecaoHome } from '../../../../model/apm/apm-enums';
import { IHomeSectionAddEditRequest } from '../../../../model/apm/home/request/home-section-add-edit-request';
import { IHomeSectionItemAddEditRequest } from '../../../../model/apm/home/request/home-section-item-add-edit-request';
import { buildSectionRequest, pickFields } from '../../components/field-config';
import { HOME_SECTION_CONFIG } from './home-section-config';

export function buildHomeSectionRequest(type: TipoSecaoHome, value: Record<string, any>): IHomeSectionAddEditRequest {
    return buildSectionRequest(HOME_SECTION_CONFIG[type].fields, value);
}

export function buildHomeItemRequest(type: TipoSecaoHome, value: Record<string, any>): IHomeSectionItemAddEditRequest {
    const itemFields = HOME_SECTION_CONFIG[type].itemFields || {};
    const picked: Record<string, any> = pickFields(itemFields, value);
    return {
        title: picked.title,
        description: picked.description,
        url: picked.url,
        image: picked.image,
        icon: picked.icon,
        openInNewTab: !!value.openInNewTab,
        // Só os tipos com período de exibição enviam as datas
        startDate: itemFields.period ? value.startDate || undefined : undefined,
        endDate: itemFields.period ? value.endDate || undefined : undefined,
        isVisible: value.isVisible !== false,
    };
}
